import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonService } from 'src/services/common.service';

@Component({
  selector: 'app-service-filter',
  templateUrl: './service-filter.component.html',
  styleUrls: ['./service-filter.component.scss'],
})
export class ServiceFilterComponent implements OnInit {

  @Input() _startDate: any;
  @Input() _endDate: any;

  refundSel: boolean = false;
  dateSel: boolean = false;
  tollSel: boolean = false;
  vehicleSel: boolean = false;
  selectedVehicle;
  selectedTollPlaza
  tollPlaza;
  vehicles;
  startDate;
  endDate;
  setStartDate;
  setEndDate
  validateDate: any = [];
  data: any = {
    startDate: '',
    endDate: ''
  };
  
  constructor(
    private _modelController: ModalController,
    private _commonService: CommonService) { }

  ngOnInit() {
    var today = new Date();
    var monthStart = this._commonService.getLastThreeMonthDate(365);
    var monthEnd = today.toISOString().substr(0, 10);
    this.setStartDate = monthStart;
    this.setEndDate = monthEnd;
    this.startDate = this._startDate;
    this.endDate = this._endDate;
  }

  rechargeSelected() {
    this.vehicleSel = false;
    this.tollSel = false;
    this.dateSel = false;
    this.refundSel = false;
  }

  refundSelected() {
    this.vehicleSel = false;
    this.tollSel = false;
    this.dateSel = false;
    this.refundSel = true;
  }

  dateSelected() {
    this.vehicleSel = false;
    this.tollSel = false;
    this.refundSel = false;
    this.dateSel = true;
  }

  vahicleSelected() {
    this.tollSel = false;
    this.vehicleSel = true;
    this.refundSel = false;
    this.dateSel = false;
  }

  tollSelected() {
    this.vehicleSel = false;
    this.tollSel = true;
    this.refundSel = false;
    this.dateSel = false;
  }

  resetFilters() {
    this.ngOnInit();
  }

  cancelDELETE() {
    this.validateDate = [];
    this._modelController.dismiss(this.data);
  }

  onDateChange(event) {
    var start_date = new Date(this.startDate);
    var end_date = new Date(this.endDate);
    if (end_date.getTime() < start_date.getTime()) {
      if (this.endDate) {
        this.endDate = this.startDate;
      }
    }
    this.validateDate.push(event);
  }

  confirm() {
    this.data.userOption = 'confirm';
    this.data.startDate = this.startDate;
    this.data.endDate = this.endDate;
    this._modelController.dismiss(this.data);
  }
  cancel() {
    this.validateDate = [];
    this.data.userOption = 'cancel';
    this._modelController.dismiss(this.data);
  }
}